export default {
  setCampaignTypes(state, data) {
    state.campaignTypes = data;
  },
  setCampaignTypeCode(state, data) {
    state.campaignTypeCode = data;
  },

  setCampaigns(state, data) {
    state.campaigns = data;
  },
  setCampaign(state, data) {
    state.campaign = data;
  },
  setCampaignCode(state, data) {
    state.campaignCode = data;
  },

  setLeadTypes(state, data) {
    state.leadTypes = data;
  },
  setLeadType(state, data) {
    state.leadType = data;
  },
  setLeadTypeCode(state, data) {
    state.leadTypeCode = data;
  },

  setLeadPropertys(state, data) {
    state.leadPropertys = data;
  },
  setLeadProperty(state, data) {
    state.leadProperty = data;
  },
  setLeadPropertyCode(state, data) {
    state.leadPropertyCode = data;
  },

  setLeadSources(state, data) {
    state.leadSources = data;
  },
  setLeadSource(state, data) {
    state.leadSource = data;
  },
  setLeadSourceCode(state, data) {
    state.leadSourceCode = data;
  },

  setChancePrioritys(state, data) {
    state.chancePrioritys = data;
  },
  setChancePriority(state, data) {
    state.chancePriority = data;
  },
  setChancePriorityCode(state, data) {
    state.chancePriorityCode = data;
  },

  setFailedSaleReasons(state, data) {
    state.failedSaleReasons = data;
  },
  setFailedSaleReasonCode(state, data) {
    state.failedSaleReasonCode = data;
  },

  setStrengthWeaknesses(state, data) {
    state.strengthWeaknesses = data;
  },
  setStrengthWeakness(state, data) {
    state.strengthWeakness = data;
  },
  setStrengthWeaknessCode(state, data) {
    state.strengthWeaknessCode = data;
  },

  setLeadEvaluationQuestions(state, data) {
    state.leadEvaluationQuestions = data;
  },
  setLeadEvaluationQuestion(state, data) {
    state.leadEvaluationQuestion = data;
  },
  setLeadEvaluationQuestionCode(state, data) {
    state.leadEvaluationQuestionCode = data;
  },

  setSaleRegions(state, data) {
    state.saleRegions = data;
  },
  setSaleRegionCode(state, data) {
    state.saleRegionCode = data;
  },

  setSaleTeams(state, data) {
    state.saleTeams = data;
  },
  setSaleTeamCode(state, data) {
    state.saleTeamCode = data;
  },

  setLeads(state, data) {
    state.leads = data;
  },
  setLead(state, data) {
    state.lead = data;
  },
  setLeadId(state, data) {
    state.leadId = data;
  },
  setLeadCode(state, data) {
    state.leadCode = data;
  },
  setLeadStatistics(state, data) {
    state.leadStatistics = data;
  },

  setChances(state, data) {
    state.chances = data;
  },
  setChance(state, data) {
    state.chance = data;
  },

  setCompetitors(state, data) {
    state.competitors = data;
  },
  setCompetitor(state, data) {
    state.competitor = data;
  },

  setLeadAddresses(state, data) {
    state.leadAddresses = data;
  },
  setLeadAddress(state, data) {
    state.leadAddress = data;
  },

  setLeadContactes(state, data) {
    state.leadContactes = data;
  },
  setLeadContact(state, data) {
    state.leadContact = data;
  },

  setSaleLines(state, data) {
    state.saleLines = data;
  },
  setSaleLineCode(state, data) {
    state.saleLineCode = data;
  },

  setSaleStageCode(state, data) {
    state.saleStageCode = data;
  },
};
